/**
 * @param {EventTarget | null} target
 * @returns {Element | null}
 */
function asElement(target) {
  if (target instanceof Element) return target;
  if (target instanceof Text) return target.parentElement;
  return null;
}

/**
 * @param {Element} target
 * @returns {HTMLAnchorElement | null}
 */
function getBecomeMemberLink(target) {
  const link = target.closest('a');
  if (!(link instanceof HTMLAnchorElement)) return null;

  if (link.closest('form[data-type="add-to-cart-form"], product-form-component')) return null;

  const label = (link.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
  if (!label.includes('become a member')) return null;

  return link;
}

const SECTION_03_ID = 'section-03';

/**
 * @returns {HTMLElement | null}
 */
function findBecomeMemberTarget() {
  const byId = document.getElementById(SECTION_03_ID);
  if (byId instanceof HTMLElement) return byId;

  const prizeHeader = document.querySelector('.prize-header-section');
  if (prizeHeader instanceof HTMLElement) return prizeHeader;

  const prizeDetails = document.querySelector('.prize-details-section');
  if (prizeDetails instanceof HTMLElement) return prizeDetails;

  return null;
}

/**
 * @returns {HTMLElement | null}
 */
function getPageScrollContainer() {
  if (!window.matchMedia('(min-width: 990px)').matches) return null;

  const pageWrapper = document.querySelector('.page-wrapper');
  if (
    pageWrapper instanceof HTMLElement &&
    pageWrapper.scrollHeight > pageWrapper.clientHeight + 1
  ) {
    return pageWrapper;
  }

  return null;
}

/**
 * @param {HTMLElement} element
 */
function scrollToElement(element) {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const behavior = prefersReducedMotion ? 'auto' : 'smooth';
  const scroller = getPageScrollContainer();

  if (!scroller) {
    element.scrollIntoView({ behavior, block: 'start' });
    return;
  }

  const scrollerRect = scroller.getBoundingClientRect();
  const elementRect = element.getBoundingClientRect();
  const headerOffset =
    parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
  const top = scroller.scrollTop + (elementRect.top - scrollerRect.top) - headerOffset - 16;

  scroller.scrollTo({ top: Math.max(0, top), behavior });
}

/**
 * @param {string | null} href
 * @returns {HTMLElement | null}
 */
function getSamePageHashTarget(href) {
  if (!href) return null;

  let url;
  try {
    url = new URL(href, window.location.href);
  } catch {
    return null;
  }

  if (url.origin !== window.location.origin) return null;
  if (!url.hash || url.hash.length < 2) return null;

  const samePage =
    url.pathname === window.location.pathname ||
    (url.pathname === '/' && (window.location.pathname === '/' || window.location.pathname === ''));
  if (!samePage) return null;

  const target = document.getElementById(decodeURIComponent(url.hash.slice(1)));
  return target instanceof HTMLElement ? target : null;
}

function goToSection03() {
  const section = findBecomeMemberTarget();
  if (section) {
    scrollToElement(section);
    return;
  }

  const root =
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  window.location.assign(`${root}#${SECTION_03_ID}`);
}

document.addEventListener(
  'click',
  (event) => {
    const target = asElement(event.target);
    if (!target) return;

    const link = getBecomeMemberLink(target);
    if (!link) return;

    event.preventDefault();
    event.stopPropagation();
    goToSection03();
  },
  true
);

document.addEventListener(
  'click',
  (event) => {
    const target = asElement(event.target);
    if (!target) return;

    const link = target.closest('a[href]');
    if (!(link instanceof HTMLAnchorElement)) return;
    if (getBecomeMemberLink(target)) return;

    const section = getSamePageHashTarget(link.getAttribute('href'));
    if (!section) return;

    event.preventDefault();
    event.stopPropagation();
    if (window.location.hash !== `#${section.id}`) {
      history.pushState(null, '', `#${section.id}`);
    }
    scrollToElement(section);
  },
  true
);

document.addEventListener('DOMContentLoaded', () => {
  if (window.location.hash === `#${SECTION_03_ID}`) {
    const section = findBecomeMemberTarget();
    if (section) {
      requestAnimationFrame(() => scrollToElement(section));
      return;
    }
  }

  const hashed = getSamePageHashTarget(window.location.href);
  if (!hashed) return;
  requestAnimationFrame(() => scrollToElement(hashed));
});
